<template>
  <div class="pricing-hero">
    <h1 class="pricing-hero-title">
      Lorem ipsum dolor sit amet, consetetur
    </h1>
    <div class="pricing-hero-body">
      <div class="pricing-slider" v-if="$vuetify.breakpoint.smAndDown">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(price, idx) in prices" :key="idx">
            <PricingItem :price-data="price" />
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div v-else :style="largeScreenContainer">
        <v-container>
          <v-row>
            <v-col
              v-for="(price, idx) in prices"
              :key="idx"
              cols="12"
              sm="6"
              md="3"
            >
              <PricingItem :price-data="price" />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PricingItem: () => import("@/components/PricingItem"),
  },
  data() {
    return {
      prices: [
        {
          title: "Starter",
          price: "Free",
          price_desc: "",
          desc: "Try it for free",
          plan: `<b>5 Credits</b>
        <span>/Month</span>`,
          btnText: "Get Started",
        },
        {
          title: "Professional",
          price: "$39",
          price_desc: "User / Month",
          desc: "Get more credits",
          plan: `<b>20 Credits</b>
        <span>/User/Month</span>`,
          btnText: "Choose Plan",
        },
        {
          title: "Premium",
          price: "$39",
          price_desc: "User / Month",
          desc: "Try it for free",
          plan: `<b>50 Credits</b>
        <span>/User/Month</span>`,
          btnText: "Choose Plan",
        },
        {
          title: "Enterprise",
          price: "",
          price_desc: "",
          desc: "Perfect for teams",
          plan: `<b>90 Credits</b>
        <span>/User/Month</span>`,
          btnText: "Choose Plan",
        },
      ],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        slidesPerView: 1,
        spaceBetween: 0,
        /* autoplay: {
          delay: 2500,
        }, */
      },
    };
  },
};
</script>

<style lang="scss">
.pricing-hero {
  &-body {
    background-color: #f2eee8;
    padding-top: 48px;
    padding-bottom: 104px;
  }

  &-title {
    font-size: 48px;
    text-align: center;
    margin-bottom: 56px;
    margin: 40px;
  }
}

@include smMax {
  .pricing {
    &-hero {
      &-title {
        font-size: 30px;
      }
      &-body {
        padding-top: 28px;
        padding-bottom: 56px;
      }
    }
    &-slider {
      .swiper-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        margin-top: 28px;

        .swiper-pagination-bullet {
          margin: 0 3px;
          transition: all 0.2s;
          height: 6px;
          width: 6px;
        }
        .swiper-pagination-bullet-active {
          background-color: $primary-color;
          height: 10px;
          width: 10px;
        }
      }
    }
  }
}
</style>
